import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { Asset } from "@/api/generated/data-contracts";
import { checkInExistingDevice, checkInNewDevice } from "@/api/CheckInApi";
import { ScannedDevice } from "@/views/inbound/inboundState";

interface MutationVariables {
  device: ScannedDevice;
}

export function useMutationCheckInDevice(
  options?: Omit<
    UseMutationOptions<Asset, unknown, MutationVariables>,
    "mutationFn"
  >,
) {
  const queryClient = useQueryClient();
  return useMutation<Asset, unknown, MutationVariables>({
    ...options,
    mutationFn: async ({ device }) => {
      const checkedInDevice = device.id
        ? await checkInExistingDevice(device.id, {
            readSerialNumber: device.readSerialNumber,
            manufacturer: device.manufacturer,
            chgManufacturerId: device.chgManufacturerId,
          })
        : await checkInNewDevice({
            orderId: device.orderId,
            manufacturer: device.manufacturer,
            chgManufacturerId: device.chgManufacturerId,
            readSerialNumber: device.readSerialNumber,
            classificationCategoryId: device.classificationCategoryId,
            productName: device.productName,
            additionalInfo: device.extraItems,
          });
      queryClient.invalidateQueries({ queryKey: ["devices"] });
      queryClient.invalidateQueries({ queryKey: ["device-stage-changes"] });
      return checkedInDevice;
    },
  });
}
